module.exports = __webpack_public_path__ + "img/xuehui.286f57c3.png";